import {
  isEmptyText,
  Prismic,
  PrismicText,
  useInlineExpressions,
} from '@landsbankinn/prismic';
import { Reveal, Segment, useMedia } from '@landsbankinn/ui';
import React from 'react';
import { Box } from '../components/box/Box';
import { BoxGroup } from '../components/box/BoxGroup';
import { Img } from '../components/img/Img';
import { PrismicTable } from '../components/table/PrismicTable';

interface IProps {
  fields: IField[];
}

interface IField {
  image: Prismic.Image;
  copy: Prismic.RichText;
  table: Prismic.RichText;
  align_content: string;
}

export const BoxesContainer = ({ fields }: IProps) => {
  const isTablet = useMedia('md');
  if (fields.length === 0) {
    return null;
  }

  return (
    <Segment>
      <BoxGroup>
        {fields.map((item, i) => {
          const copy = !isEmptyText(item.copy) ? (
            <PrismicText value={item.copy} />
          ) : null;
          //const source = Prismic.text(item?.table);
          const source = Prismic.text(item?.table) ?? '';
          return (
            <Box
              key={`box-${i}`}
              noPadding={!!item.image}
              isTable={!!item.table}
              center={item.align_content}
            >
              {!!item.image ? (
                <Reveal>
                  <Img
                    src={item.image}
                    ar={isTablet ? 'ar_16_9' : 'ar_1_1'}
                    aspectRatio={isTablet ? 16 / 9 : 1 / 1}
                  />
                </Reveal>
              ) : !!copy ? (
                <Reveal>{copy}</Reveal>
              ) : (
                <PrismicTable
                  noHeadingUnderline={false}
                  background="Gray"
                  layout="Small"
                >
                  <div dangerouslySetInnerHTML={{ __html: source }} />
                  {/*<PrismicText value={item?.table} />*/}
                  {/*        <ReactMarkdown rehypePlugins={[rehypeRaw, rehypeSanitize]}>
                    {source ?? ''}
                  </ReactMarkdown> */}
                </PrismicTable>
              )}
            </Box>
          );
        })}
      </BoxGroup>
    </Segment>
  );
};
